.bundle-summary {
  padding: $space-02;

  @include agl-ds-screen-size('large') {
    min-width: 165px;
    padding: 0;
  }

  &__info,
  .empty-bundle {
    @include agl-ds-screen-size('large') {
      display: flex !important;
      flex-direction: column;
    }
  }

  &__info {
    min-height: 55px;
    align-items: flex-start;
    text-align: left;
    margin-bottom: 0;

    @include agl-ds-screen-size('large') {
      min-height: auto;
      margin-bottom: 3px !important;
    }
  }

  .bundled-category {
    @include agl-ds-screen-size('large') {
      margin-bottom: 2px !important;
    }
  }

  .empty-bundle {
    min-height: 55px;

    @include agl-ds-screen-size('large') {
      align-items: center;
      justify-content: center;
      min-height: 168px;
    }

    &__info {
      text-align: center;
      padding: 0 $space-01;
    }
  }

  &__cta {
    min-width: calc(100% - 32px);
    text-align: center;
    margin-bottom: $space-02;

    @include agl-ds-screen-size('large') {
      margin-bottom: 0;
    }
  }
}
